export const randomStringCharSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_ ';
export const randomString = (min: number, max: number) => {
  const charOut = [];
  const charSet = randomStringCharSet;
  const charLen = Math.floor(Math.random() * (max - min + 1) + min);
  for (let i = 0; i < charLen; i++) {
    const charIdx = Math.floor(Math.random() * charSet.length);
    const char = charSet.charAt(charIdx);
    charOut.push(char);
  }
  return charOut.join('');
};

export const randomDate = (min: Date, max: Date) => {
  const out = new Date(0);
  const emin = min.getTime() / 1000;
  const emax = max.getTime() / 1000;
  const enew = Math.floor(Math.random() * (emax - emin + 1) + emin);
  out.setUTCSeconds(enew);
  return out;
};

export const randomChoice = <T>(arr: T[]): T => {
  return arr[Math.floor(Math.random() * arr.length)];
};
